// extracted by mini-css-extract-plugin
export default {"sctTable":"SCTTable_sctTable__jFcZy","table":"SCTTable_table__1+txW","input":"SCTTable_input__dVqvS"};